import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import useInstantPayEnabled from './useInstantPayEnabled';

const useInstantPayEligible = () => {
  const isInstantPayEnabled = useInstantPayEnabled();

  // SEA computes isInstantPayAllowed itself (enabled, onboarding complete, custodial funding
  // confirmed, and USD) — the client only adds the feature flag check on top.
  // Only Name Your Rate markets submit as Instant Pay.
  const isInstantPayEligible = (takerMarket: TakerMarket): boolean => {
    return (
      isInstantPayEnabled && takerMarket.isInstantPayAllowed && takerMarket.marketPricingType === 'PRICE_DISCOVERY'
    );
  };

  return { isInstantPayEligible };
};

export default useInstantPayEligible;
